var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Flex, FormControl, FormLabel, Input } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { ScaleLoader } from 'react-spinners';
import { BaseDialog, BaseDialogState } from '@/app/UIComponents/BaseDialog';
import { APPEvent } from '@/events/AppEvents';
import { ProjectObjectType } from '@@/Project';
import { Apphandler } from '@/ipc/MainAppHandler';
export class BookmarkState {
    constructor() {
        this.name = "";
        this.url = "";
        this.loading = false;
        this.activeletrid = "";
        this.activefolderid = "";
        this.basedialogState = new BaseDialogState();
        makeObservable(this);
        this.basedialogState.setCancelLabel("Cancel");
        this.basedialogState.setOkLabel("Create");
        this.basedialogState.setHeaderLabel("Add Bookmark");
        this.basedialogState.setDisableOkButton(true);
        this.basedialogState.onClose = () => this.setOpen(false);
        this.basedialogState.onOk = () => this.addBookmark();
        APPEvent.addSubscriberForCreateObject((ob) => {
            if (this.loading && ob.letrid === this.activeletrid) {
                if (ob.project !== undefined) {
                    APPEvent.publishProjectObject(ob.project);
                    this.setOpen(false);
                }
                else {
                    APPEvent.publishApperror("Sorry failed to create folder");
                }
                this.setLoading(false);
            }
        });
    }
    addBookmark() {
        if (!this.name.trim() || !this.url.trim()) {
            return;
        }
        this.setLoading(true);
        const bfolder = {
            id: "",
            name: this.name,
            parentid: this.activefolderid,
            url: this.url,
            updatetime: 0,
            type: ProjectObjectType.Bookmark,
            accessids: []
        };
        const req = {
            letrid: this.activeletrid,
            project: bfolder
        };
        Apphandler.sendMessage("createproject", req);
    }
    setOpen(open) {
        this.basedialogState.setOpen(open);
        if (open) {
            this.setName("");
            this.setURL("");
            this.setLoading(false);
        }
    }
    setName(name) {
        this.name = name;
        this.toggleOkButton();
    }
    setURL(url) {
        this.url = url;
        this.toggleOkButton();
    }
    setLoading(loading) {
        this.loading = loading;
    }
    toggleOkButton() {
        if (this.name.trim() && this.url.trim()) {
            this.basedialogState.setDisableOkButton(false);
        }
        else {
            this.basedialogState.setDisableOkButton(true);
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], BookmarkState.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], BookmarkState.prototype, "url", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], BookmarkState.prototype, "loading", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], BookmarkState.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], BookmarkState.prototype, "setURL", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], BookmarkState.prototype, "setLoading", null);
let BookmarkDialog = class BookmarkDialog extends React.Component {
    constructor(prop) {
        super(prop);
    }
    dialog() {
        return React.createElement(Box, null,
            React.createElement(FormControl, { id: 'bookmark-name' },
                React.createElement(FormLabel, null, "Name"),
                React.createElement(Input, { onChange: (e) => this.props.state.setName(e.currentTarget.value), type: 'text', value: this.props.state.name })),
            React.createElement(FormControl, { id: 'bookmark-link' },
                React.createElement(FormLabel, null, "Bookmark Link"),
                React.createElement(Input, { onChange: (e) => this.props.state.setURL(e.currentTarget.value), type: 'text', value: this.props.state.url })),
            this.props.state.loading && React.createElement(Flex, { mt: '20px', align: 'center', justify: 'center', w: '100%' },
                React.createElement(ScaleLoader, { color: 'green' })));
    }
    render() {
        return (React.createElement(BaseDialog, { body: this.dialog(), state: this.props.state.basedialogState }));
    }
};
BookmarkDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], BookmarkDialog);
export { BookmarkDialog };
